import React from 'react';
import { ValueContainerProps } from 'react-select';
import { OptionTypeBase } from 'react-select/src/types';

export const ValueContainer = (props: ValueContainerProps<OptionTypeBase, boolean>) => (
  <div className={props.selectProps.classes.valueContainer}>{props.children}</div>
);
